{
  "loading": "Nalaganje...",
  "placeholder": "Izberite…"
}
